export const modalState = {
  FORM: 'FORM',
  SUCCESS: 'SUCCESS',
  EULA: 'EULA',
};
